<template>
  <div class="d-flex flex-grow-1">
    <v-navigation-drawer
      id="navigation-drawer"
      :class="{ offline: isOffline }"
      v-model="drawer"
      app
      width="300"
      floating
      :right="$vuetify.rtl"
      :light="menuTheme === 'light'"
      :dark="menuTheme === 'dark'"
    >
      <!-- v-if="(typeof $route.query.outletId) !=='undefined' && $route.query.outletId > 0 " -->
      <template #prepend>
        <div class="pa-2">
          <div class="title font-weight-bold primary--text">
            {{ product.name }}
          </div>
          <div class="overline grey--text">
            {{ product.version }}
            <v-badge
              v-if="isDemoHotel()"
              color="error"
              content="DEMO"
              inline
            />
          </div>
        </div>
      </template>

      <div class="arch-menu">
        <v-list-item v-if="showHotelSidebarLogo">
          <v-img :src="hotelSidebarLogo" />
        </v-list-item>
        <ArchNavMenu
          :key="i"
          :item="item"
          @set-component="setComponent"
          @set-start-load-comp="setStartLoadComp"
          @set-visible="setVisible"
          :start-load-comp="startLoadComp"
          :loading.sync="loading"
          v-for="(item, i) in menus"
        />
      </div>
      <template #append>
        <div class="pa-1 text-center">
          <v-btn
            v-for="(item, index) in navigation.footer"
            :key="index"
            :href="item.href"
            :target="item.target"
            small
            text
          >
            {{ item.key ? $t(item.key) : item.text }}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      id="navigation-header"
      :class="{ offline: isOffline }"
      app
      :color="isToolbarDetached ? 'surface' : undefined"
      :flat="isToolbarDetached"
      :light="toolbarTheme === 'light'"
      :dark="toolbarTheme === 'dark'"
    >
      <v-card
        class="flex-grow-1 d-flex h-inherit"
        :class="[isToolbarDetached ? 'pa-1 mt-3 mx-1' : 'pa-0 ma-0']"
        :flat="!isToolbarDetached"
      >
        <div class="d-flex flex-grow-1 align-center">
          <v-text-field
            v-if="showSearch"
            append-icon="mdi-close"
            placeholder="Search"
            prepend-inner-icon="mdi-magnify"
            hide-details
            solo
            flat
            autofocus
            @click:append="showSearch = false"
          />
          <div
            v-else
            class="d-flex flex-grow-1 align-center"
          >
            <v-app-bar-nav-icon
              @click.stop="drawer = !drawer"
              :small="$vuetify.breakpoint.smAndDown"
            />
            <v-spacer
              :class="{'d-none': isSearching || $vuetify.breakpoint.smAndUp}"
            />
            <v-menu
              v-model="searchResultVisible"
              :close-on-content-click="true"
              transition="slide-y-transition"
              offset-y
            >
              <template #activator="{ on, attrs }">
                <div class="flex-grow-1 flex-shrink-1">
                  <v-btn
                    icon
                    @click="isSearching = !isSearching"
                    class="btn-40"
                    v-if="$vuetify.breakpoint.mdAndDown"
                    v-show="$vuetify.breakpoint.mdAndDown && !isSearching"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                  <v-text-field
                    ref="search"
                    v-model="searchKeyword"
                    class="mx-1"
                    placeholder="Search something here..."
                    :name="`random-${Math.random()}`"
                    prepend-inner-icon="mdi-magnify"
                    hide-details
                    filled
                    rounded
                    clearable
                    v-show="$vuetify.breakpoint.lgAndUp || ($vuetify.breakpoint.mdAndDown && isSearching)"
                    @click="
                      () => {
                        if (
                          searchResultItems.length > 0 &&
                          searchKeyword.length > 0
                        ) {
                          searchResultVisible = true;
                        }
                      }
                    "
                    @keyup="showSearchResult"
                    @keydown.up.prevent="pressUp"
                    @keydown.down.prevent="pressDown"
                    @keydown.enter.prevent="pressEnter"
                    @click:prepend-inner="isSearching = false"
                    dense
                  />
                </div>
              </template>
              <!-- {{ searchResultItems }} -->
              <v-card style="padding: 10px">
                <div
                  style="max-height: 400px; overflow: auto"
                  id="sr-container"
                >
                  <div
                    v-for="(item, i) in getSearchResultItems()"
                    :key="i"
                    :id="`sr-${i}`"
                  >
                    <div
                      style="padding: 5px; font-size: smaller; color: #b9b2b2"
                      v-html="item.parentText"
                    />
                    <div style="padding-left: 20px">
                      <v-list-item
                        :link="isExternalOrDialogMenu(child) ? false : true"
                        dense
                        v-for="(child, j) in item.items"
                        :key="`search-${j}`"
                        :to="isExternalOrDialogMenu(child) ? undefined : $parseURL(child.link || '')"
                        @click="
                          isExternalOrDialogMenu(child) ? openExternalOrDialogMenu(child) : () => {}
                        "
                        :input-value="selected === i"
                        :style="selected === i && `background: #CFD8DC;`"
                      >
                        <v-list-item-icon>
                          <v-icon v-text="child.icon" />
                        </v-list-item-icon>
                        <v-list-item-title>
                          {{ child.text }}
                          <v-icon
                            v-if="child.external"
                            small
                            color="grey lighten"
                            class="pl-1"
                          >
                            mdi-window-restore
                          </v-icon>
                        </v-list-item-title>
                      </v-list-item>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-menu>
            <v-btn
              icon
              @click="onClickQuickOrderToolbar"
              class="btn-40"
              v-if="$store.state.app?.last_closed_day?.is_show_quick_order_in_toolbar"
              v-show="isShowOtherIcons"
            >
              <v-icon>
                mdi-cart
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="onClickNfcToolbar"
              class="btn-40"
              v-if="$store.state.app?.last_closed_day?.is_show_nfc_in_toolbar"
              v-show="isShowOtherIcons"
            >
              <v-icon>
                mdi-nfc
              </v-icon>
            </v-btn>
            <span v-show="isShowOtherIcons">
              <toolbar-language />
              <ToolbarHotelChains />
              <ToolbarHotels />
              <ToolbarOutlets
                v-if="$route.query.hotelId > -1"
              />
              <ToolbarClosedDay
                v-if="$route.query.outletId > -1"
              />
            </span>
            <toolbar-user />
          </div>
        </div>
      </v-card>
    </v-app-bar>
    <v-main id="main-area">
      <st-announcement-component :announcement-app="announcementApp">
        <v-container
          id="main-container"
          :class="[
            ($route.name === 'tables' || $route.name === 'quick-order') && $route.params.tableId
              ? 'table-detail'
              : '',
            $vuetify.breakpoint.smAndDown && ($route.name === 'tables' || $route.name === 'quick-order') ? 'px-0 pt-0' : ''
          ]
          "
          class="fill-height"
          :fluid="!isContentBoxed"
          v-if="
            (typeof $route.query.outletId !== 'undefined' &&
              $route.query.outletId > 0) ||
              $route.path.includes('/master-data') ||
              $route.path.includes('/agent')
          "
        >
          <v-layout>
            <slot />
          </v-layout>
        </v-container>
        <v-row
          v-else
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            lg="6"
            md="6"
            class="fill-height d-flex flex-column justify-center align-center"
          >
            <OutletNotFoundPage />
          </v-col>
        </v-row>
      </st-announcement-component>
    </v-main>
    <component
      v-if="startLoadComp"
      :is="component"
      :visible.sync="visible"
      :loading="loading"
      :data.sync="data"
      @close="close"
      @mounted="onCompMounted"
    />
  </div>
</template>

<script>
import config from "../configs";
import MainMenu from "@/components/navigation/MainMenu";
import ToolbarUser from "@/components/toolbar/ToolbarUser";
import ToolbarLanguage from "@/components/toolbar/ToolbarLanguage";
import ToolbarHotels from "@/components/toolbar/ToolbarHotels";
import ToolbarHotelChains from "@/components/toolbar/ToolbarHotelChains";
import ToolbarOutlets from "@/components/toolbar/ToolbarOutlets";
import ToolbarClosedDay from "@/components/toolbar/ToolbarClosedDay";
import ToolbarNotifications from "@/components/toolbar/ToolbarNotifications";
import { mapState } from "vuex";
import ArchNavMenu from "@/components/navigation/ArchNavMenu";
import navigation from "@/configs/navigation";
import OutletNotFoundPage from "@/pages/error/OutletNotFoundPage";
import reports from "@/configs/reports";
import PermissionHelper from "@/permissions/PermissionHelper";
import { PermissionEnum } from "@/permissions/PermissionEnum";
import { passesEntryActionGate } from "@/permissions/entryActionGate";
import StAnnouncementComponent from "sentec-vues/modules/announcement/components/StAnnouncementComponent";
import { AnnouncementApp } from "sentec-vues/modules/announcement/enums/AnnouncementApp";
import configApi from "@/services/Api-config";
import { ActionButtonEnum } from "@/permissions/ActionButtonEnum";
import { GenericCrudRequestQueryBuilder } from "sentec-core-ts";
import ApiConfig from "@/services/Api-config";

export default {
  components: {
    MainMenu,
    ToolbarUser,
    ToolbarLanguage,
    ToolbarNotifications,
    ToolbarHotels,
    ToolbarHotelChains,
    ToolbarOutlets,
    ToolbarClosedDay,
    ArchNavMenu,
    OutletNotFoundPage,
    StAnnouncementComponent,
    "st-bracelet-nfc-dialog": () => import("sentec-vues/components/STBraceletNFCDialog.vue"),
  },
  data() {
    return {
      drawer: null,
      showSearch: false,
      searchKeyword: "",
      searchResultVisible: false,
      searchResultItems: [],
      navigation: config.navigation,
      selected: 0,
      announcementApp: AnnouncementApp.POS,
      component: "",
      startLoadComp: false,
      visible: false,
      data: null,
      loading: false,
      isSearching: false,
      showHotelSidebarLogo: false,
      hotelSidebarLogo: "",
    };
  },
  computed: {
    ...mapState("app", [
      "isOffline",
      "product",
      "isContentBoxed",
      "menuTheme",
      "toolbarTheme",
      "isToolbarDetached",
      "parameter"
    ]),
    menus() {
      const isShowQuickOrderInMenu = this.parameter.is_show_quick_order_in_menu || false;
      if (
        typeof this.$route.query.outletId !== "undefined" &&
        this.$route.query.outletId > 0
      ) {
        const menu = this.navigation.menu;
        return isShowQuickOrderInMenu ? menu : menu.filter(el => el.link != "/quick-order");
      } else {
        const temp = [this.navigation.menu?.[5]];
        temp[0].expanded = true;
        if (temp[0]?.items?.[0]) {
          temp[0].items[0].expanded = true;
        }
        return isShowQuickOrderInMenu ? temp : temp.filter(el => el.link != "/quick-order");
      }
    },
    isShowOtherIcons() {
      return this.$vuetify.breakpoint.lgAndUp || (this.$vuetify.breakpoint.mdAndDown && !this.isSearching);
    },
    hotelId() {
      return this.$route.query.hotelId;
    }
  },
  mounted() {
    this.loadCurrentHotel();
  },
  methods: {
    isDemoHotel() {
      return Number(this.$route.query.hotelId) <= 100;
    },
    onKeyup(e) {
      this.$refs.search.focus();
    },
    showSearchResult(ev){
      if (this.searchKeyword && this.searchKeyword.length>0) {
        const keyword = this.searchKeyword.toLowerCase();
        this.searchResultItems=[];
        this.initSearchResultItems(
          {
            items: [...navigation.menu, ...reports.reports],
          },
          {},
          keyword
        );
        this.searchResultVisible = true;
      } else {
        this.searchResultVisible = false;
      }
    },
    initSearchResultItems(item, parent, keyword){
      const self=this;
      if (item.items!=null){
        item.items.forEach(i => {
          const theItem=item;
          theItem.parentText=parent.text;
          self.initSearchResultItems(i, theItem, keyword);
        });
      } else {const textToSearch =
        (item.text || "") +
        (this.$t(item.key) || "") +
        (item.keywords || "") +
        (parent.text || "") +
        (this.$t(parent.key) || "") +
        (parent.keywords || "");
      const keywords = keyword.split(" ");
      let valid = true;
      let parentText = parent.text || this.$t(parent.key);
      for (const k of keywords) {
        if (textToSearch.toLowerCase().indexOf(k) == -1) {
          valid = false;
        }
      }
      // A plain (non-dialog) entry may also carry `permission-enum`; when it does, that action gates
      // it in addition to the menu check. Without this, a role holding only the `/reports/*` wildcard
      // finds the BIR reports through this search box — the menu matcher accepts the wildcard — and
      // lands on a page that then refuses it. Entries without `permission-enum` are unaffected.
      if (
        (valid && item["is-dialog-menu"] && PermissionHelper.canAccessButton(ActionButtonEnum[item["permission-enum"]])) ||
          (valid && !item["is-dialog-menu"] && passesEntryActionGate(item) &&
          PermissionHelper.canAccess({ type: PermissionEnum.MENU, item: item }))
      ) {
        if (parent.parentText && parent.parentText.length > 0) {
          parentText =
              parent.parentText +
              " <span style='color: black !important;'>&rarr;</span> " +
              parentText;
        }
        this.searchResultItems.push({
          parentText,
          items: [item],
        });
      }
      }
    },
    getSearchResultItems() {
      const parents = [];
      const items = [];
      this.searchResultItems.forEach((i) => {
        const item = {
          ...i,
        };
        if (parents.indexOf(i.parentText) != -1) {
          item.parentText = null;
        } else {
          parents.push(i.parentText);
        }
        items.push(item);
      });
      return items;
    },
    pressUp() {
      if (this.selected > 0) {
        const temp = this.selected - 1;
        this.selected = temp;
        const cont = document.getElementById("sr-container");
        const item = document.getElementById(`sr-${temp}`);
        if (Number(item?.offsetTop) < Number(cont?.scrollTop)) {
          cont?.scrollTo({ top: Number(item?.offsetTop) });
        }
      }
    },
    pressDown() {
      const res = this.getSearchResultItems();
      if (this.selected < res.length - 1) {
        const temp = this.selected + 1;
        this.selected = temp;
        const cont = document.getElementById("sr-container");
        const item = document.getElementById(`sr-${temp}`);
        if (
          Number(item?.offsetTop) + Number(item?.clientHeight) >
          Number(cont?.scrollTop) + Number(cont?.clientHeight)
        ) {
          cont?.scrollTo({
            top:
              Number(item?.offsetTop) +
              Number(item?.clientHeight) -
              Number(cont?.clientHeight),
          });
        }
      }
    },
    onClickNfcToolbar() {
      this.openExternalOrDialogMenu({
        "is-dialog-menu": true,
        "component": "st-bracelet-nfc-dialog"
      }, { isCheckStatus: true });
    },
    onClickQuickOrderToolbar() {
      this.$router.push({ ...this.$route, name: "quick-order", params: {} });
    },
    pressEnter() {
      const res = this.getSearchResultItems();
      if (res[this.selected].items[0]["is-dialog-menu"] || res[this.selected].items[0].external) {
        this.openExternalOrDialogMenu(res[this.selected].items[0]);
      } else {
        this.$router.push(res[this.selected].items[0].link).catch(() => {});
        setTimeout(() => {
          this.searchResultVisible = false;
        }, 50);
      }
    },
    onCompMounted() {
      if (!this.data) {
        this.visible = true;
      }
    },
    openExternalOrDialogMenu(item, data = null) {
      if (item["is-dialog-menu"]) {
        this.data = data;
        this.component = item.component;
        if (!this.startLoadComp) {
          this.startLoadComp = true;
        } else if (!data) {
          this.visible = true;
        }
      } else {
        let urlFo = configApi.ST_WEB_FO;
        let linkExternal = item.link + "?hotelId=" + this.$route.query.hotelId;
        window.open(urlFo + linkExternal);
      }
    },
    close() {
      this.visible = false;
    },
    isExternalOrDialogMenu(item) {
      return item.external || item["is-dialog-menu"];
    },
    setStartLoadComp(v) {
      this.startLoadComp = v;
    },
    setVisible(v) {
      this.visible = v;
    },
    setComponent(v) {
      this.component = v;
    },
    async loadCurrentHotel() {
      const query = new GenericCrudRequestQueryBuilder()
        .filter("id", this.hotelId)
        .build();
      const res = await this.$http.get(`/hotel/${this.hotelId}/dto/public.hotel/v1?${query}`);

      if (res.data?.Data?.length > 0) {
        const hotel = res.data.Data[0];
        this.showHotelSidebarLogo = hotel.show_sidebar_menu_logo;
        this.hotelSidebarLogo = hotel.sidebar_menu_logo_url ? ApiConfig.ST_STORAGE_STATIC_URL + String(hotel.sidebar_menu_logo_url) : "";
      }
    }
  },
  watch: {
    searchResultItems(n, o) {
      if (n.length !== o?.length) {
        this.selected = 0;
        const cont = document.getElementById("sr-container");
        cont?.scrollTo({ top: 0 });
      }
    },
  },
};
</script>
<style lang="scss">
.offline {
  top: 25px !important;
}
.v-navigation-drawer .fa:before,
.v-navigation-drawer .fas:before {
  font-size: 18px !important;
}
.arch-menu .v-list-item {
  border-radius: 5px;
}
.arch-menu .v-list-item--active {
  color: var(--v-primary-base);
}
#main-container {
  padding-top: 12px;
}
.table-detail {
  height: calc(100vh - 64px);
}
.h-inherit {
  height: inherit !important;
}
.btn-40 {
  width: 40px !important;
  height: 40px !important;
}

/* Fix mobile toolbar overflow */
@media (max-width: 599px) {
  #navigation-header {
    overflow-x: hidden;
  }

  #navigation-header .v-card {
    overflow-x: hidden;
  }

  .d-flex.flex-grow-1.align-center {
    overflow-x: hidden;
    min-width: 0;
  }
}
</style>
